import { create } from 'zustand'

export type TipoToast = 'success' | 'errore' | 'info'

export interface Toast {
  id: string
  messaggio: string
  tipo: TipoToast
  durataMs: number
}

interface StatoToast {
  toasts: Toast[]
  mostra: (messaggio: string, tipo?: TipoToast, durataMs?: number) => void
  rimuovi: (id: string) => void
}

/**
 * Store globale dei toast.
 * I componenti chiamano `mostra(...)` per pushare un toast.
 * Il `<ToastContainer />` montato in App.tsx li rendera in basso a destra.
 */
let contatore = 0

export const useToastStore = create<StatoToast>((set) => ({
  toasts: [],
  mostra: (messaggio, tipo = 'success', durataMs = 3500) => {
    const id = `t-${++contatore}-${Date.now()}`
    set((s) => ({ toasts: [...s.toasts, { id, messaggio, tipo, durataMs }] }))
  },
  rimuovi: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))

/** Hook di comodità: restituisce solo le funzioni di trigger. */
export function useToast() {
  const mostra = useToastStore((s) => s.mostra)
  return {
    successo: (m: string, ms?: number) => mostra(m, 'success', ms),
    errore: (m: string, ms?: number) => mostra(m, 'errore', ms ?? 5000),
    info: (m: string, ms?: number) => mostra(m, 'info', ms),
  }
}
